module.exports = __webpack_public_path__ + "static/media/ic_filter.82ac06d8.svg";